// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PpReportStateMapper from "../entity-mapper/PpReportStateMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

var execute = PpReportStateMapper.execute;

var PpResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var PpResponseConverter = partial_arg(PpResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  PpResponseConverterConfig ,
  PpResponseConverter ,
  
}
/* PpResponseConverter Not a pure module */
